import { render, staticRenderFns } from "./GenresInfo.vue?vue&type=template&id=75906d50&scoped=true&"
import script from "./GenresInfo.vue?vue&type=script&lang=js&"
export * from "./GenresInfo.vue?vue&type=script&lang=js&"
import style0 from "./GenresInfo.vue?vue&type=style&index=0&id=75906d50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75906d50",
  null
  
)

export default component.exports